exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".JYny4kWVOzoRsS-PG7c-P{width:300px}.JYny4kWVOzoRsS-PG7c-P._52XN1YmkUx5zfBezQd9he{width:350px}.JYny4kWVOzoRsS-PG7c-P ._37uGIxEe-gR0ElJ-Ngoril{display:flex;position:relative;flex-wrap:wrap;margin-bottom:-5px}.JYny4kWVOzoRsS-PG7c-P ._23MZ3ly2iwNjNfbCg8nrL0 ._3Zc5c79x4wKOHj6jLl8fHk{flex:1 1 auto;max-width:25%;min-width:20%;margin-right:10px}.JYny4kWVOzoRsS-PG7c-P ._3Zc5c79x4wKOHj6jLl8fHk{flex:1 1 32%;max-width:33%;min-width:30%}.JYny4kWVOzoRsS-PG7c-P ._3Zc5c79x4wKOHj6jLl8fHk ._1isMFnebAgSmAy3rxRhBFO{padding-bottom:15px}.JYny4kWVOzoRsS-PG7c-P ._3Zc5c79x4wKOHj6jLl8fHk ._1isMFnebAgSmAy3rxRhBFO .cglF5QqksTmJ06XatU-IL{font-weight:bold;font-size:14px;margin-bottom:2px}.JYny4kWVOzoRsS-PG7c-P ._3Zc5c79x4wKOHj6jLl8fHk ._1isMFnebAgSmAy3rxRhBFO ._3T5QQT4zfeTO0yrq123aH7{white-space:nowrap}\n", ""]);

// Exports
exports.locals = {
	"SegmentPopup": "JYny4kWVOzoRsS-PG7c-P",
	"ultrawide": "_52XN1YmkUx5zfBezQd9he",
	"metrics": "_37uGIxEe-gR0ElJ-Ngoril",
	"fourCol": "_23MZ3ly2iwNjNfbCg8nrL0",
	"col": "_3Zc5c79x4wKOHj6jLl8fHk",
	"metric": "_1isMFnebAgSmAy3rxRhBFO",
	"value": "cglF5QqksTmJ06XatU-IL",
	"label": "_3T5QQT4zfeTO0yrq123aH7"
};